class DmTrackOrder extends HTMLElement {
  connectedCallback() {
    const dataEl = this.querySelector('[data-dm-orders]');
    this.orders = dataEl ? JSON.parse(dataEl.textContent) : [];

    this.form = this.querySelector('[data-dm-track-form]');
    this.input = this.querySelector('#dm-track-input');
    this.error = this.querySelector('[data-dm-track-error]');
    this.result = this.querySelector('[data-dm-track-result]');

    if (!this.form) return; // signed-out state has no form
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.#track(this.input.value.trim());
    });

    // Deep link from Order History (?order=DM1234): prefill and track
    // immediately so that click feels like one continuous page, not a
    // second manual step.
    const prefill = new URLSearchParams(window.location.search).get('order');
    if (prefill) {
      this.input.value = prefill;
      this.#track(prefill);
    }
  }

  #normalize(name) {
    return name.replace(/^#/, '').trim().toLowerCase();
  }

  #track(value) {
    const target = this.#normalize(value);
    const order = this.orders.find((o) => this.#normalize(o.name) === target);

    if (!order) {
      this.error.hidden = false;
      this.result.hidden = true;
      return;
    }

    this.error.hidden = true;
    this.#render(order);
  }

  // Three steps only (fixed 2026-08-06) — true delivery/shipment status
  // isn't exposed to theme Liquid at all (Admin API/webhooks only, see
  // dm-track-order.liquid), so "fulfilled" is as far as this can honestly
  // confirm. isFulfilled itself already falls back past a laggy summary
  // field to checking for a real Fulfillment record — see
  // dm-order-is-fulfilled.liquid.
  #statusIndex(order) {
    return order.isFulfilled ? 2 : 1; // 1 = placed + preparing
  }

  #render(order) {
    const idx = this.#statusIndex(order);

    this.querySelector('[data-dm-track-number]').textContent = order.name;

    this.querySelectorAll('[data-step]').forEach((el, i) => {
      el.classList.remove('is-done', 'is-current');
      if (i < idx) el.classList.add('is-done');
      else if (i === idx) el.classList.add('is-current');
    });

    this.querySelector('[data-dm-track-fill]').style.width = `${(idx / 2) * 100}%`;

    const eta = this.querySelector('[data-dm-track-eta]');
    eta.textContent = order.city
      ? `On its way to ${order.city}.`
      : 'We’ll update this as your order moves.';

    this.result.hidden = false;
  }
}

customElements.define('dm-track-order', DmTrackOrder);
